import { LocalTime } from "@js-joda/core";
import React from "react";

interface Props {
  value: LocalTime | null;
  onChange: (value: LocalTime | null) => void;
}

const TimePicker = (props: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "") {
      return props.onChange(null);
    }

    props.onChange(LocalTime.parse(e.target.value));
  };

  return (
    <input
      className="TimePicker"
      type="time"
      value={props.value?.toString() ?? ""}
      onChange={handleChange}
    />
  );
};

export default TimePicker;
